// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/remote_filter_query" endpoint
 */
import type { EngagementFilterTypeDisplayName } from "@dashboardApi/apis/engagementFilterType";

import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementRemoteFilterQuery } from "./constants";
import type { EngagementRemoteFilterQueryResult, EngagementFilterQueryExtras } from "./types";

export const getEngagementRemoteFilterQuery = reactQueryFetcherAdapter(
  engagementRemoteFilterQuery,
  (
    signal: AbortSignal,
    appGroupId: string,
    limit: number,
    filterKey: string,
    displayName: EngagementFilterTypeDisplayName,
    prefilterValue?: string,
    query?: string,
    additionalParams?: EngagementFilterQueryExtras
  ): Promise<EngagementRemoteFilterQueryResult[]> => {
    const params = {
      display_name: displayName,
      app_group_id: appGroupId,
      "additional_params[pre_filter_value]": prefilterValue,
      filter_key: filterKey,
      limit,
      query,
    };

    if (additionalParams?.seg_id) {
      params["additional_params[seg_id]"] = additionalParams.seg_id;
    }

    if (additionalParams?.workflow_id) {
      params["additional_params[workflow_id]"] = additionalParams?.workflow_id;
    }

    return fetch(engagementRemoteFilterQuery, "GET", params, { signal });
  }
);
